module.exports = __webpack_public_path__ + "static/media/Copy.e81c2347.svg";